import { AutocompleteInputModel, SubmitGroupItemModel, TextInputModel } from '@libs/form/models';

export const userTokenConfig: TextInputModel = {
  type: 'text',
  name: 'user-token',
  label: 'User Token',
};

export const customerNumberConfig: AutocompleteInputModel = {
  type: 'autocomplete',
  name: 'customer-number',
  label: 'Customer Number',
  allowArbitraryValue: true,
  options: [],
};

export const submitConfig: SubmitGroupItemModel = {
  type: 'submit',
  items: [
    {
      name: 'apply',
      label: 'Apply',
      theme: 'filled',
    },
  ],
};
